// removed by extract-text-webpack-plugin
module.exports = {"title":"_2g7qUbpF0Cp6uBB1a8OnC0","buttonNew":"yIGCt8RPocFndWnmm-4oT","searchField":"koJBY-rW2hQWvHuMyHx4D"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Order/style.scss
// module id = 1239
// module chunks = 0